/**
 * Legacy ReportingApiService module — preserved as a near-empty AngularJS
 * module so existing dependencies (`acme.common.service.reportingApi`) keep
 * resolving.
 *
 * The actual ReportingApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/reporting/reporting-api.service.ts
 *
 * The `ReportingConstant` AngularJS constant is kept on this module because
 * ReportsListController.js still injects it directly via AngularJS DI to
 * compare async-report statuses. The constant has no AngularJS-only API —
 * it's just a string map — and moving it would require touching the only
 * consumer, so we leave it here for now.
 */
angular
  .module("acme.common.service.reportingApi", [
    "acme.common.factory.QueryStringBuilder",
    "acme.common.service.helpers",
  ])
  .constant("ReportingConstant", {
    async: {
      status: {
        pending: "Pending",
        processing: "Processing",
        completed: "Completed",
        error: "Error",
      },
    },
  });
